import { Activity, type ReactNode } from "react";
import { useAppConfig } from "../AppConfig";
import { WorkspaceLoading } from "../shell/WorkspaceLoading";
import { SignInForm } from "./SignInForm";
import { useAccountSnapshot } from "./useAccountSnapshot";

/** Keep workspace content and shortcuts unmounted until the session is authenticated. */
export function AuthGate({ children }: { children: ReactNode }) {
  const { hasServer, account } = useAppConfig();
  const session = useAccountSnapshot(account);
  if ((!hasServer && !account) || session.phase === "signed_in") return children;

  return (
    <>
      {session.phase === "checking" && <WorkspaceLoading />}
      <Activity mode={session.phase === "checking" ? "hidden" : "visible"}>
        <main className="flex h-full flex-col overflow-y-auto bg-bg px-6 py-12 text-fg">
          <section aria-labelledby="sign-in-heading" className="m-auto w-full max-w-sm shrink-0">
            <p className="mb-8 text-sm font-medium text-fg-muted">HQ</p>
            <h1 id="sign-in-heading" className="text-2xl font-semibold tracking-tight">
              {session.setupRequired === true
                ? "Set up your workspace"
                : session.setupRequired === false
                  ? "Sign in to your workspace"
                  : "Open your workspace"}
            </h1>
            <p className="mt-3 mb-8 text-sm leading-relaxed text-fg-muted">
              Your notes, tasks, and plans, together across your devices.
            </p>
            {account ? (
              <SignInForm account={account} />
            ) : (
              <p role="alert" className="text-sm text-danger">
                Sign-in is unavailable. Please reload and try again.
              </p>
            )}
          </section>
        </main>
      </Activity>
    </>
  );
}
